import React from 'react';



class Block extends React.Component {
  render() {
    return <h1>Hello, {this.props.name}</h1>;
  }
}

export default Block;